import { createSelector } from '@reduxjs/toolkit';
const authRoot = state => state.auth;
export const hubspotUserIdSelector = createSelector(authRoot, ({
  user
}) => user.userId);
export const hubspotUserEmailSelector = createSelector(authRoot, ({
  user
}) => user.email);
export const hubspotUserLocaleSelector = createSelector(authRoot, ({
  user
}) => user.locale.locale);
export const gatesSelector = createSelector(authRoot, ({
  portal,
  user
}) => portal.enabledGates.length ? portal.enabledGates : user.enabledGates);
export const isLoadingSelector = createSelector(authRoot, ({
  isLoading
}) => isLoading);
export const firstNameSelector = createSelector(authRoot, ({
  user
}) => user.firstName);
export const lastNameSelector = createSelector(authRoot, ({
  user
}) => user.lastName);
export const scopesSelector = createSelector(authRoot, ({
  portal
}) => portal.scopes || []);
export const currentAccountSelector = createSelector(authRoot, ({
  currentAccount
}) => currentAccount);
export const prosemirrorTrackerPropertiesSelector = createSelector(authRoot, ({
  user,
  portal
}) => ({
  email: user.email || null,
  hubId: portal.portalId,
  lang: portal.locale.locale || null
}));